import { Injectable } from '@angular/core';
import { TagModel } from './model/tag.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TagService {

 
  constructor(private http: HttpClient) { }

  getTagList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/tag/get', requestData);

  }

  /**
   * 
   * @param tagInfo 
   * Calls the update API to insert/update the record
   */
  update(tagInfo: TagModel): Observable<any> { 
    if(tagInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/tag/update', tagInfo);
    } else{
      return this.http.post(environment.baseUrl+'/tag/add', tagInfo);
    }
  }

  /**
   * 
   * @param tagInfo 
   * Calls the API to delete the record
   */
  delete(tagInfo: TagModel): Observable<any>  {
    return this.http.post(environment.baseUrl+'/tag/delete/'+tagInfo.id, tagInfo);
  }
}
